export default {
  META: 'meta',
  DATA: 'data',
  TYPE: 'type',
  ID: 'id',
  LINKS: 'links',
  LINK: {
    SELF: 'self',
    ORDER: 'order',
    PROCESS: 'process',
    OPTIONS: 'options',
    PAGE: 'page',
    ALLOW: 'allow',
    HREF: 'href',
    PAGE_PREV: 'page/prev',
    PAGE_NEXT: 'page/next',
    PAGE_LIST: 'page/list',
    PAGE_ITEM: 'page/item',
    LIST: 'list', // ProductElement PrevNextListLink
    PREV: 'prev', // ProductElement PrevNextListLink
    NEXT: 'next', // ProductElement PrevNextListLink
    PRODUCT: 'product',
  },
  ALLOW: {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
  },
  RELATIONSHIPS: 'relationships',
  INCLUDED: 'included',
  ATTRIBUTES: 'attributes',
}
